module.exports = require("next/dist/compiled/jsonwebtoken");